import request from "./request";

/**
 * @description 优惠券模板 -- 列表
 */
export function couponListApi(data) {
  return request.get('store/coupon/lst', data);
}
/**
 * @description 优惠券模板 -- 新增表单
 */
export function couponCreateApi() {
  return request.get('store/coupon/create/form');
}
/**
 * @description 优惠券模板 -- 编辑表单
 */
export function couponUpdateApi(id) {
  return request.get("store/coupon/update/".concat(id, "/form"));
}
/**
 * @description 优惠券模板 -- 发布优惠券
 */
export function couponIssueApi(id) {
  return request.get("store/coupon/issue/create/form/".concat(id));
}

/**
 * @description 已发布优惠券 -- 列表
 */
export function couponIssueListApi(data) {
  return request.get('store/coupon/lst', data);
}
/**
 * @description 已发布优惠券 -- 修改状态
 */
export function couponIssueStatusApi(id, status) {
  return request.post("store/coupon/status/".concat(id), {
    status: status
  });
}
/**
 * @description 已发布优惠券 -- 添加优惠券
 */
export function couponIssuePushApi() {
  return request.get("store/coupon/create/form");
}
/**
 * @description 优惠券列表 -- 删除
 */
export function couponIssueDeleteApi(id) {
  return request.delete("store/coupon/issue/".concat(id));
}
/**
 * @description 优惠券列表 -- 复制
 */
export function couponCloneApi(id) {
  return request.get("store/coupon/clone/form/".concat(id));
}
/**
 * @description 优惠券列表 -- 领取记录
 */
export function issueApi(data) {
  return request.get("store/coupon/issue", data);
}
/**
 * @description 赠送优惠券组件列表 -- 列表
 */
export function couponSelectApi(data) {
  return request.get("store/coupon/select", data);
}
/**
 * @description 优惠券列表 -- 详情
 */
export function couponDetailApi(coupon_id) {
  return request.get("store/coupon/detail/".concat(coupon_id));
}
/**
 * @description 优惠劵 -- 删除
 */
export function couponDeleteApi(coupon_id) {
  return request.delete("store/coupon/delete/".concat(coupon_id));
}
/**
 * @description 优惠劵 -- 发送
 */
export function couponSendApi(data) {
  return request.post("store/coupon/send", data);
}
/**
 * @description 优惠券发送记录 -- 列表
 */
export function couponSendLstApi(data) {
  return request.get("store/coupon_send/lst", data);
}
/**
 * @description 预售商品 -- 列表排序
 */
export function presellProSort(id, data) {
  return request.post("/store/product/presell/sort/".concat(id), data);
}
/**
 * @description 助力商品 -- 列表排序
 */
export function assistProSort(id, data) {
  return request.post("/store/product/assist/sort/".concat(id), data);
}
/**
 * @description 优惠券详情 -- 关联商品列表
 */
export function couponRelateProLst(id, data) {
  return request.get("/store/coupon/product/".concat(id), data);
}
/**
 * @description 积分 -- 积分配置
 */
export function integralConfigApi(key) {
  return request.get("config/".concat(key));
}
/**
 * @description 积分 -- 积分统计
 */
export function integralTitleApi() {
  return request.get("integral/title");
}
/**
 * @description 积分 -- 积分列表
 */
export function integralLstApi(data) {
  return request.get("integral/lst", data);
}
/**
 * @description 创建套餐 -- 获取商品规格
 */
export function productAttrsApi(id) {
  return request.get("store/product/attr_value/".concat(id));
}
/**
 * @description 创建套餐 -- 获取商品规格
 */
export function discountsSave(data) {
  return request.post("discounts/create", data);
}

/**
 * @description 套餐列表 -- 列表数据
 */
export function discountsList(data) {
  return request.get("discounts/lst", data);
}

/**
 * @description 套餐列表 -- 显示状态（上下架）
 */
export function discountsChangeStatus(id, status) {
  return request.post("discounts/status/".concat(id), {
    status: status
  });
}
/**
 * @description 套餐列表 -- 详情
 */
export function discountsGetDetails(id) {
  return request.get("discounts/detail/".concat(id));
}
/**
 * @description 套餐列表 -- 删除
 */
export function discountsDelete(id) {
  return request.delete("discounts/delete/".concat(id));
}
/**
 * @description 创建套餐 -- 获取商品规格
 */
export function discountsUpdate(id, data) {
  return request.post("discounts/update/".concat(id), data);
}
/** 报名活动 -- 关联的表单信息 */
export function associatedFormInfo(id, data) {
  return request.get("system/form/info/".concat(id), data);
}